import axios, { AxiosStatic } from 'axios';
import applyCaseMiddleware from 'axios-case-converter'
import qs from 'qs';
import {isClient} from 'src/common/razzle-platform-components/utils'
// import { setupCache } from 'axios-cache-adapter'

axios.interceptors.request.use((config) => {

    if (isClient) {
        const token = localStorage.getItem('authentication_token');

        if (token) {
            config.headers.Authorization = token;
        }
    }

    config.paramsSerializer = (params) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
    }

    return config;
})
// todo: implement later
// // Create `axios-cache-adapter` instance
// const cache = setupCache({
//     maxAge: 15 * 60 * 1000,
//     exclude: {
//         methods: ['delete', 'patch', 'post', 'put']
//     }
// })

// // Create `axios` instance passing the newly created `cache.adapter`
// const axiosed = axios.create({
//     adapter: cache.adapter
// })


export default applyCaseMiddleware(axios, {
    ignoreHeaders: true,
    caseFunctions: {
        snake: (input: string, options: never) => {
            return (input.split(/(?=[A-Z])/).join('_')).toLowerCase()
        }
    },
    preservedKeys: ['marginBounds', 'margin_bounds', 'inCenter', 'in_center']
}) as AxiosStatic
